import React, { useEffect } from 'react';
import useTheme4A from '../components/useTheme4A';

// The games suite now lives as self-contained HTML files under /games/.
// Each game saves state to localStorage and runs its own session timer.
// We redirect the React route /games to the static /games/index.html
// menu so the game set can be updated without a code change.
function GamesPage() {
  useTheme4A();
  useEffect(() => {
    window.location.replace('/games/index.html');
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <p className="text-base text-black">Loading games…</p>
    </div>
  );
}

export default GamesPage;
